import { defineStore } from 'pinia';
import { IPersonalizeStore } from '@/interfaces/personalize/personalize-store.interface';

const INITIAL_STATE: IPersonalizeStore = {
  personalizeForm: {
    city: undefined,
    arrival: undefined,
    departure: undefined,
    name: undefined,
    lastname: undefined,
    location: undefined,
    birthdate: undefined,
    purpose: 'student',
  },
};

export const usePersonalizeStore = defineStore({
  id: 'personalize',
  state: (): IPersonalizeStore => ({
    ...INITIAL_STATE,
  }),
  getters: {},
  actions: {
    resetStore() {
      this.personalizeForm = {
        city: undefined,
        arrival: undefined,
        departure: undefined,
        name: undefined,
        lastname: undefined,
        location: undefined,
        birthdate: undefined,
        purpose: 'student',
      };
    },
  },
  persist: {},
});

export type PersonalizeStore = ReturnType<typeof usePersonalizeStore>;
